import { getDimensionMeasurement } from '@r-core/helpers';

const FLAT_TRIM_NAMES: Record<string, string> = {
	'34.5-34.5': 'GRILL HEIGHT',
	'39.25-39.25': 'BAR HEIGHT',
	'37-37': 'PIZZA/CORNER HEIGHT',
	'39.25-34.5': 'L-SHAPE',
	'37-34.5': 'PIZZA/CORNER HEIGHT W/ GRILL HEIGHT',
	'39.25-37': 'PIZZA/CORNER HEIGHT W/ BAR HEIGHT'
};

export const getFlatTrimName = (leftHeight: number, rightHeight: number, isStepped: boolean): string => {
	const left = getDimensionMeasurement(leftHeight, false);
	const right = getDimensionMeasurement(rightHeight, false);
	const tall = getDimensionMeasurement(Math.max(leftHeight, rightHeight), false);
	const short = getDimensionMeasurement(Math.min(leftHeight, rightHeight), false);

	const base = FLAT_TRIM_NAMES[`${tall}-${short}`] ?? `${left}" / ${right}"`;
	if (!isStepped) return base;

	// the spec sheet names a piece after the side its step falls on, the opposite side from its taller half
	return `${base} (${leftHeight > rightHeight ? 'Right Aligned' : 'Left Aligned'})`;
};
